import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

/* ── SVG icon ── */
const Ic = ({ d, size = 15, sw = 1.6 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth={sw} strokeLinecap="round"
    strokeLinejoin="round" style={{ flexShrink: 0, display: 'block' }}>
    {Array.isArray(d) ? d.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
  </svg>
);

const I = {
  sun:    'M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42M12 5a7 7 0 100 14A7 7 0 0012 5z',
  moon:   'M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z',
  logout: ['M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4','M16 17l5-5-5-5','M21 12H9'],
  bell:   ['M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9','M13.73 21a2 2 0 01-3.46 0'],
  search: 'M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0',
  menu:   ['M4 6h16','M4 12h16','M4 18h16'],
  home:   'M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z',
  chevR:  'M9 18l6-6-6-6',
  clock:  ['M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z','M12 6v6l4 2'],
  dots:   ['M12 5h.01','M12 12h.01','M12 19h.01'],
  dash:   ['M3 13h8V3H3v10z','M13 21h8v-8h-8v8z','M13 3v6h8V3h-8z','M3 21v-4h8v4H3z'],
  bed:    ['M3 7v11','M21 7v11','M3 12h18','M5 7h14a2 2 0 012 2v1H3V9a2 2 0 012-2z','M7 12v4','M17 12v4'],
  money:  ['M12 1v22','M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6'],
  shield: ['M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z'],
  broom:  ['M3 22l9-9','M7 8l10 10','M17.5 3.5a2.121 2.121 0 013 3L8 19l-5 1 1-5L17.5 3.5z'],
  chart:  ['M18 20V10','M12 20V4','M6 20v-6'],
  bag:    ['M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z','M3 6h18','M16 10a4 4 0 01-8 0'],
  fork:   ['M12 22v-6','M12 8V2','M8 8h8','M8 2v6a4 4 0 008 0V2'],
  people: ['M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2','M9 7a4 4 0 100 8 4 4 0 000-8z','M23 21v-2a4 4 0 00-3-3.87','M16 3.13a4 4 0 010 7.75'],
  wave:   ['M2 12c.6.5 1.2 1 2.5 1C7 13 7 11 9.5 11s2.5 2 5 2 2.5-2 5-2 2.5 2 2.5 2'],
  star:   'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z',
  box:    ['M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z'],
  speaker:['M11 5L6 9H2v6h4l5 4V5z'],
  car:    ['M5 17H3a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v10a2 2 0 01-2 2h-2','M17 21a2 2 0 100-4 2 2 0 000 4z','M7 21a2 2 0 100-4 2 2 0 000 4z'],
};

const ROLE_LABELS = {
  admin:'Administrator', waiter:'Waiter', cashier:'Cashier', kitchen:'Kitchen',
  chef:'Head Chef', reception:'Receptionist', gate:'Gate', housekeeping:'Housekeeping',
  accountant:'Accountant', gift_shop:'Gift Shop', restaurant_manager:'Restaurant',
  marketing:'Marketing', hr:'Human Resources', storekeeper:'Storeroom',
  swimming_attendant:'Pool Attendant', kids_amenities:'Kids Zone', driver:'Driver',
};

const ROLE_ICON = {
  admin:I.dash, reception:I.bed, cashier:I.money, waiter:I.fork,
  kitchen:I.fork, chef:I.fork, housekeeping:I.broom, gate:I.shield,
  accountant:I.chart, gift_shop:I.bag, restaurant_manager:I.bag,
  marketing:I.speaker, hr:I.people, storekeeper:I.box,
  swimming_attendant:I.wave, kids_amenities:I.star, driver:I.car,
};

const ini = n => (n||'?').split(' ').map(w=>w[0]).join('').toUpperCase().slice(0,2);

export function NotificationBell({ count, onClick }) {
  return (
    <button onClick={onClick} className="topbar-icon-btn" style={{ position: 'relative' }}>
      <Ic d={I.bell} size={16} />
      {count > 0 && (
        <span style={{ position:'absolute',top:1,right:1,background:'#C9A84C',color:'#1B3A2D',
          borderRadius:'50%',fontSize:8,fontWeight:800,width:15,height:15,
          display:'flex',alignItems:'center',justifyContent:'center' }}>
          {count > 9 ? '9+' : count}
        </span>
      )}
    </button>
  );
}

export default function Layout({ children, onNotifClick, notifCount = 0, sideContent, breadcrumb }) {
  const { user, logout, isDemo } = useAuth();
  const { theme, toggleMode } = useTheme();
  const [time, setTime] = useState(new Date().toLocaleTimeString('en-KE',{hour:'2-digit',minute:'2-digit'}));
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' && window.innerWidth < 960);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const closeMobileNav = useCallback(() => setMobileNavOpen(false), []);

  useEffect(() => {
    const iv = setInterval(() => setTime(new Date().toLocaleTimeString('en-KE',{hour:'2-digit',minute:'2-digit'})), 60000);
    return () => clearInterval(iv);
  }, []);

  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth < 960;
      setIsMobile(mobile);
      if (!mobile) setMobileNavOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') closeMobileNav(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [closeMobileNav]);

  useEffect(() => {
    document.body.style.overflow = mobileNavOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileNavOpen]);

  const isDark = theme.mode === 'dark';
  const SIDE = isMobile ? 0 : (collapsed ? 60 : 234);
  const TOP  = 54;

  // Sidebar = deep green both modes
  const SB = isDark ? '#0F211A' : '#1B3A2D';
  const GOLD = '#C9A84C';

  return (
    <div style={{ minHeight:'100vh', background:'var(--bg)', color:'var(--textPrimary)',
      fontFamily:"'Plus Jakarta Sans',-apple-system,sans-serif", fontSize:13, lineHeight:1.5 }}>

    {/* ── Demo mode banner ─────────────────────────────────────────────── */}
    {isDemo && (
      <div style={{
        position:'sticky', top:0, zIndex:10000,
        background:'linear-gradient(90deg,#f4a261,#c45e3e)',
        color:'#fff', textAlign:'center',
        padding:'9px 16px', fontSize:13, fontWeight:600,
        display:'flex', alignItems:'center', justifyContent:'center', gap:14,
        boxShadow:'0 2px 12px rgba(196,94,62,0.4)',
        letterSpacing:0.2,
      }}>
        <span>🎯 Demo Mode — All data is read-only. No changes will be saved.</span>
        <button
          onClick={logout}
          style={{
            background:'rgba(255,255,255,0.2)', border:'1px solid rgba(255,255,255,0.4)',
            borderRadius:6, padding:'3px 12px', cursor:'pointer',
            fontSize:12, fontWeight:700, color:'#fff', fontFamily:'inherit',
            transition:'background .15s',
          }}
          onMouseEnter={e => e.currentTarget.style.background='rgba(255,255,255,0.3)'}
          onMouseLeave={e => e.currentTarget.style.background='rgba(255,255,255,0.2)'}
        >
          Exit Demo
        </button>
      </div>
    )}

    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

      *, *::before, *::after { box-sizing: border-box; margin:0; padding:0; }
      html { font-size: 13px; }
      body, #root {
        font-family: 'Plus Jakarta Sans', -apple-system, sans-serif !important;
        background: var(--bg); overflow-x: hidden;
        -webkit-font-smoothing: antialiased;
      }
      :root {
        --r: 12px; --r-sm: 8px; --r-lg: 16px;
        --gold: #C9A84C;
        --green-dark: #1B3A2D;
        --transition: .15s cubic-bezier(.4,0,.2,1);
      }

      /* ── Scrollbars ── */
      ::-webkit-scrollbar { width: 4px; height: 4px; }
      ::-webkit-scrollbar-track { background: transparent; }
      ::-webkit-scrollbar-thumb { background: rgba(201,168,76,0.25); border-radius: 99px; }
      .noscroll { scrollbar-width: none; }
      .noscroll::-webkit-scrollbar { display: none; }

      /* ── Form inputs ── */
      input, select, textarea {
        font-family: 'Plus Jakarta Sans', -apple-system, sans-serif !important;
        font-size: 13px !important;
        color: var(--textPrimary) !important;
        background: var(--bgCard) !important;
        border: 1.5px solid var(--borderMid) !important;
        border-radius: var(--r-sm) !important;
        padding: 8px 12px !important;
        line-height: 1.5 !important;
        width: 100%;
        outline: none !important;
        transition: border-color var(--transition), box-shadow var(--transition) !important;
        -webkit-appearance: none; appearance: none;
      }
      input::placeholder, textarea::placeholder { color: var(--textFaint) !important; }
      input:focus, select:focus, textarea:focus {
        border-color: var(--gold) !important;
        box-shadow: 0 0 0 3px rgba(201,168,76,0.15) !important;
      }
      select {
        cursor: pointer;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='11' viewBox='0 0 24 24' fill='none' stroke='%23706860' stroke-width='2.5'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E") !important;
        background-repeat: no-repeat !important;
        background-position: right 10px center !important;
        padding-right: 30px !important;
      }
      textarea { resize: vertical; min-height: 72px; }
      button { font-family: 'Plus Jakarta Sans', -apple-system, sans-serif !important; cursor: pointer; touch-action: manipulation; }
      a { color: var(--gold); text-decoration: none; }
      img, video { max-width: 100%; height: auto; }

      /* ── Shell — topbar fixed, sidebar fixed, main offset ── */
      .gs-shell {
        min-height: 100vh;
      }

      /* ── Topbar — fixed full-width at top ── */
      .gs-topbar {
        position: fixed;
        top: 0; left: 0; right: 0;
        z-index: 400;
        background: ${SB};
        display: flex; align-items: center;
        height: ${TOP}px;
      }

      /* Logo zone */
      .gs-logo-zone {
        width: ${SIDE}px; flex-shrink: 0; height: 100%;
        display: flex; align-items: center; gap: 10px;
        padding: 0 16px;
        border-right: 1px solid rgba(255,255,255,0.08);
        overflow: hidden;
        transition: width .22s cubic-bezier(.4,0,.2,1);
      }
      .gs-logo-mark {
        width: 34px; height: 34px; flex-shrink: 0; border-radius: 50%;
        background: ${GOLD};
        display: flex; align-items: center; justify-content: center;
        font-size: 15px; font-weight: 800; color: ${SB};
        box-shadow: 0 2px 8px rgba(201,168,76,0.4);
      }
      .gs-logo-name { font-size: 14px; font-weight: 800; color: #fff; white-space: nowrap; letter-spacing: -.2px; overflow: hidden; text-overflow: ellipsis; }
      .gs-logo-tag  { font-size: 9px; color: rgba(255,255,255,0.45); margin-top: 1px; font-weight: 500; letter-spacing: .3px; }

      /* Topbar breadcrumb */
      .gs-breadcrumb {
        flex: 1; display: flex; align-items: center; gap: 5px;
        font-size: 12.5px; color: rgba(255,255,255,0.5);
        padding: 0 12px; overflow: hidden;
      }
      .gs-breadcrumb .crumb-active { color: #fff; font-weight: 600; }
      .gs-breadcrumb .crumb-sep { color: rgba(255,255,255,0.25); font-size: 14px; }

      /* Topbar icon button */
      .topbar-icon-btn {
        display: flex; align-items: center; justify-content: center;
        width: 34px; height: 34px; border-radius: 8px;
        border: none; background: rgba(255,255,255,0.07);
        color: rgba(255,255,255,0.65); cursor: pointer;
        transition: all var(--transition); flex-shrink: 0;
        position: relative;
      }
      .topbar-icon-btn:hover { background: rgba(255,255,255,0.14); color: #fff; }

      /* Topbar search */
      .gs-search {
        display: flex; align-items: center; gap: 7px;
        background: rgba(255,255,255,0.1);
        border: 1px solid rgba(255,255,255,0.1);
        border-radius: 8px; padding: 0 12px;
        height: 34px; width: 220px; flex-shrink: 0;
      }
      .gs-search input {
        background: transparent !important; border: none !important;
        color: rgba(255,255,255,0.85) !important; font-size: 12px !important;
        padding: 0 !important; width: 100%; box-shadow: none !important;
      }
      .gs-search input::placeholder { color: rgba(255,255,255,0.38) !important; }
      .gs-search input:focus { box-shadow: none !important; border: none !important; }

      /* Topbar right cluster */
      .gs-topbar-right {
        display: flex; align-items: center; gap: 6px; padding-right: 16px; flex-shrink: 0;
      }
      .topbar-sep { width: 1px; height: 20px; background: rgba(255,255,255,0.12); margin: 0 4px; flex-shrink: 0; }

      /* ── Sidebar — fixed on the left, full height minus topbar ── */
      .gs-sidebar {
        position: fixed;
        top: ${TOP}px;
        left: 0;
        bottom: 0;
        background: ${SB};
        display: flex; flex-direction: column;
        overflow: hidden;
        transition: width .22s cubic-bezier(.4,0,.2,1);
        width: ${SIDE}px;
        z-index: 300;
      }

      /* Nav section label */
      .nav-section {
        padding: 18px 16px 6px;
        font-size: 10px; font-weight: 700;
        text-transform: uppercase; letter-spacing: .1em;
        color: rgba(255,255,255,0.3);
        white-space: nowrap; overflow: hidden;
      }

      /* Nav item */
      .nav-item {
        display: flex; align-items: center; gap: 10px;
        padding: 9px 12px; margin: 2px 10px;
        border-radius: 10px;
        border: none; background: transparent; width: calc(100% - 20px);
        text-align: left; font-family: inherit; font-size: 13px;
        font-weight: 500; color: rgba(255,255,255,0.65);
        cursor: pointer; transition: all var(--transition);
        white-space: nowrap; overflow: hidden; min-height: 36px;
      }
      .nav-item:hover { background: rgba(255,255,255,0.08); color: rgba(255,255,255,0.9); }
      .nav-item.active {
        background: ${GOLD};
        color: ${SB};
        font-weight: 700;
        box-shadow: 0 2px 10px rgba(201,168,76,0.35);
      }
      .nav-item-icon { width: 18px; height: 18px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; }
      .nav-item-label { overflow: hidden; text-overflow: ellipsis; flex: 1; }

      /* Sidebar user footer */
      .gs-sidebar-foot {
        margin-top: auto; border-top: 1px solid rgba(255,255,255,0.08);
        padding: 14px 12px; flex-shrink: 0;
      }
      .gs-user-card {
        border-radius: 12px; background: rgba(255,255,255,0.07);
        padding: 10px 10px 8px; overflow: hidden;
      }
      .gs-avatar {
        flex-shrink: 0; border-radius: 50%;
        display: flex; align-items: center; justify-content: center;
        font-weight: 700; letter-spacing: .3px; font-size: 10px;
      }

      /* ── Main — offset for fixed topbar + sidebar ── */
      .gs-main {
        margin-left: ${SIDE}px;
        margin-top: ${TOP}px;
        padding: 24px 28px 40px;
        overflow-x: hidden; min-width: 0;
        background: var(--bg);
        min-height: calc(100vh - ${TOP}px);
        transition: margin-left .22s cubic-bezier(.4,0,.2,1);
      }
      .main-content * { min-width: 0; }

      /* ── COMPONENT LIBRARY ── */

      /* Cards — white, rounded 12px */
      .gs-card {
        background: var(--bgCard);
        border: 1px solid var(--border);
        border-radius: var(--r);
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0,0,0,0.06);
      }
      .card-header {
        display: flex; align-items: center; justify-content: space-between;
        padding: 14px 18px; border-bottom: 1px solid var(--border);
        gap: 8px; flex-wrap: wrap; min-height: 46px;
      }
      .card-title { font-size: 14px; font-weight: 700; color: var(--textPrimary); }
      .card-body  { padding: 18px; }

      /* Compat aliases */
      .section-card { background:var(--bgCard); border:1px solid var(--border); border-radius:var(--r); overflow:hidden; margin-bottom:16px; box-shadow:0 2px 8px rgba(0,0,0,0.06); }
      .section-card-header { display:flex;align-items:center;justify-content:space-between;padding:14px 18px;border-bottom:1px solid var(--border); min-height:46px; }
      .section-card-title { font-size:14px;font-weight:700;color:var(--textPrimary);display:flex;align-items:center;gap:8px; }
      .section-card-body { padding:18px; }

      /* Stat tiles */
      .stat-tile {
        background: var(--bgCard); border: 1px solid var(--border);
        border-radius: var(--r); padding: 18px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.06);
        transition: box-shadow var(--transition);
      }
      .stat-tile:hover { box-shadow: 0 6px 20px rgba(0,0,0,0.1); }
      .stat-label { font-size: 11px; font-weight: 700; color: var(--textMuted); text-transform: uppercase; letter-spacing: .06em; margin-bottom: 10px; display: flex; align-items: center; justify-content: space-between; }
      .stat-value { font-size: 26px; font-weight: 800; color: var(--textPrimary); letter-spacing: -.5px; line-height: 1; }
      .stat-trend { font-size: 11.5px; font-weight: 600; display: flex; align-items: center; gap: 3px; margin-top: 6px; }
      .stat-up    { color: #16a34a; } .stat-down { color: #dc2626; } .stat-neutral { color: var(--textMuted); }

      /* Tables */
      .gs-table { width: 100%; border-collapse: collapse; font-size: 13px; }
      .gs-table th {
        padding: 10px 14px; text-align: left;
        font-size: 11px; font-weight: 700; color: var(--textMuted);
        letter-spacing: .05em; text-transform: uppercase;
        border-bottom: 1.5px solid var(--border);
        background: var(--bgInput); white-space: nowrap;
      }
      .gs-table th:first-child { border-radius: var(--r-sm) 0 0 0; }
      .gs-table th:last-child  { border-radius: 0 var(--r-sm) 0 0; }
      .gs-table td { padding: 11px 14px; border-bottom: 1px solid var(--border); color: var(--textSecond); vertical-align: middle; }
      .gs-table td:first-child { color: var(--textPrimary); font-weight: 600; }
      .gs-table tbody tr { transition: background .1s; }
      .gs-table tbody tr:hover { background: var(--bgHover); }
      .gs-table tbody tr:last-child td { border-bottom: none; }

      /* Badges */
      .badge { display:inline-flex;align-items:center;gap:3px;padding:3px 9px;border-radius:6px;font-size:11.5px;font-weight:600;line-height:1.5;white-space:nowrap; }
      .badge-green  { background:#f0fdf4; color:#15803d; border:1px solid #bbf7d0; }
      .badge-red    { background:#fef2f2; color:#b91c1c; border:1px solid #fecaca; }
      .badge-amber  { background:#fffbeb; color:#92400e; border:1px solid #fde68a; }
      .badge-blue   { background:#eff6ff; color:#1d4ed8; border:1px solid #bfdbfe; }
      .badge-gray   { background:#f9fafb; color:#52525b; border:1px solid #e4e4e7; }
      .badge-purple { background:#f5f3ff; color:#6d28d9; border:1px solid #ddd6fe; }
      .badge-gold   { background:#fffbeb; color:#92400e; border:1px solid #C9A84C; }
      ${isDark ? `
      .badge-green  { background:rgba(34,197,94,.1);  color:#4ade80; border-color:rgba(74,222,128,.2); }
      .badge-red    { background:rgba(239,68,68,.1);  color:#f87171; border-color:rgba(248,113,113,.2); }
      .badge-amber  { background:rgba(245,158,11,.1); color:#fbbf24; border-color:rgba(251,191,36,.2); }
      .badge-blue   { background:rgba(59,130,246,.1); color:#60a5fa; border-color:rgba(96,165,250,.2); }
      .badge-gray   { background:rgba(113,113,122,.1);color:#a1a1aa; border-color:rgba(161,161,170,.2); }
      .badge-purple { background:rgba(139,92,246,.1); color:#a78bfa; border-color:rgba(167,139,250,.2); }
      .badge-gold   { background:rgba(201,168,76,.12);color:#C9A84C; border-color:rgba(201,168,76,.3); }
      ` : ''}

      /* Status dots */
      .status-dot { width:7px;height:7px;border-radius:50%;display:inline-block;flex-shrink:0; }
      .status-dot.green{background:#22c55e;} .status-dot.amber{background:#f59e0b;}
      .status-dot.red{background:#ef4444;} .status-dot.blue{background:#3b82f6;}
      .status-dot.gray{background:#71717a;} .status-dot.gold{background:#C9A84C;}

      /* Tabs — gold active underline */
      .tab-bar-container, .pg-tabs-row {
        display: flex; gap: 0; overflow-x: auto;
        margin-bottom: 20px; border-bottom: 1.5px solid var(--border);
        scrollbar-width: none;
      }
      .tab-bar-container::-webkit-scrollbar, .pg-tabs-row::-webkit-scrollbar { display: none; }
      .tab-btn, .pg-tab {
        display: inline-flex; align-items: center; gap: 6px;
        padding: 0 16px; height: 40px;
        border: none; border-bottom: 2.5px solid transparent;
        background: transparent; font-family: inherit; font-size: 13px;
        font-weight: 500; color: var(--textMuted); cursor: pointer;
        white-space: nowrap; transition: all var(--transition);
        margin-bottom: -1.5px; flex-shrink: 0;
      }
      .tab-btn:hover, .pg-tab:hover { color: var(--textPrimary); }
      .tab-btn.active, .pg-tab.active { color: var(--gold); border-bottom-color: var(--gold); font-weight: 700; }

      /* Buttons */
      .btn { display:inline-flex;align-items:center;gap:7px;padding:8px 16px;border-radius:var(--r-sm);font-size:13px;font-weight:600;font-family:inherit;cursor:pointer;transition:all var(--transition);white-space:nowrap;border:none; }
      .btn-primary { background:var(--gold);color:#1B3A2D;font-weight:700; }
      .btn-primary:hover { background:#b8953e; }
      .btn-green  { background:#1B3A2D;color:#fff; }
      .btn-green:hover { background:#163324; }
      .btn-default { background:var(--bgCard);color:var(--textSecond);border:1.5px solid var(--borderMid); }
      .btn-default:hover { background:var(--bgHover);border-color:var(--borderStrong);color:var(--textPrimary); }
      .btn-ghost  { background:transparent;color:var(--textSecond);border:1.5px solid transparent; }
      .btn-ghost:hover { background:var(--bgHover);color:var(--textPrimary); }
      .btn-danger { background:transparent;color:#dc2626;border:1.5px solid #fca5a5; }
      .btn-danger:hover { background:#fef2f2; }
      .btn-sm { padding:5px 11px;font-size:12px; }
      /* Legacy */
      .qa-btn { display:inline-flex;align-items:center;gap:6px;padding:7px 14px;border-radius:var(--r-sm);border:1.5px solid var(--borderMid);background:var(--bgCard);font-size:13px;font-weight:500;cursor:pointer;font-family:inherit;transition:all var(--transition);color:var(--textSecond);white-space:nowrap; }
      .qa-btn:hover { background:var(--bgHover);border-color:var(--borderStrong);color:var(--textPrimary); }
      .qa-btn.primary { background:var(--gold);border-color:var(--gold);color:#1B3A2D;font-weight:700; }
      .qa-btn.primary:hover { background:#b8953e;border-color:#b8953e; }
      .qa-btn.danger { background:transparent;border-color:#fca5a5;color:#dc2626; }
      .qa-btn.danger:hover { background:#fef2f2; }

      /* Room cells */
      .room-cell { border:1.5px solid var(--border);border-radius:var(--r-sm);padding:10px 6px;text-align:center;font-weight:700;font-size:13px;cursor:pointer;transition:all var(--transition); }
      .room-cell:hover { box-shadow:0 4px 14px rgba(0,0,0,.12);transform:translateY(-1px); }
      .room-cell.available { background:#f0fdf4;border-color:#86efac;color:#15803d; }
      .room-cell.occupied  { background:#f0f7ff;border-color:#93c5fd;color:#1d4ed8; }
      .room-cell.dirty     { background:#fffbeb;border-color:#fde047;color:#92400e; }
      .room-cell.maintenance { background:#fef2f2;border-color:#fca5a5;color:#b91c1c; }
      .room-cell.inspecting  { background:#f5f3ff;border-color:#c4b5fd;color:#6d28d9; }
      .room-cell.empty       { background:var(--bgInput);border-color:var(--border);color:var(--textFaint); }
      ${isDark ? `
      .room-cell.available { background:rgba(34,197,94,.08);border-color:rgba(34,197,94,.25);color:#4ade80; }
      .room-cell.occupied  { background:rgba(59,130,246,.08);border-color:rgba(59,130,246,.25);color:#60a5fa; }
      .room-cell.dirty     { background:rgba(245,158,11,.08);border-color:rgba(245,158,11,.25);color:#fbbf24; }
      .room-cell.maintenance { background:rgba(239,68,68,.08);border-color:rgba(239,68,68,.25);color:#f87171; }
      .room-cell.inspecting  { background:rgba(139,92,246,.08);border-color:rgba(139,92,246,.25);color:#a78bfa; }
      ` : ''}

      /* Modal */
      .gs-modal-overlay { position:fixed;inset:0;background:var(--bgModal);z-index:1000;display:flex;align-items:center;justify-content:center;padding:16px; }
      .modal-inner { background:var(--bgCard);border:1px solid var(--border);border-radius:var(--r-lg);box-shadow:0 20px 60px rgba(0,0,0,.18);max-height:calc(100vh - 48px);overflow-y:auto;width:100%; }

      /* Form helpers */
      .form-grid   { display:grid; grid-template-columns:1fr 1fr; gap:14px; }
      .form-grid-3 { display:grid; grid-template-columns:1fr 1fr 1fr; gap:14px; }
      .divider { height:1px;background:var(--border);margin:14px 0; }

      /* Focus-visible rings */
      .nav-item:focus-visible,
      .tab-btn:focus-visible,
      .pg-tab:focus-visible,
      .topbar-icon-btn:focus-visible,
      .btn:focus-visible,
      .qa-btn:focus-visible {
        outline: 2px solid #C9A84C;
        outline-offset: 2px;
      }

      /* Mobile drawer */
      .gs-mobile-drawer {
        position: fixed;
        top: 0; left: 0; bottom: 0;
        width: 260px;
        background: ${SB};
        z-index: 1100;
        display: flex; flex-direction: column;
        transform: translateX(-100%);
        transition: transform .22s cubic-bezier(.4,0,.2,1);
        overflow-y: auto;
      }
      .gs-mobile-drawer.open { transform: translateX(0); }
      .gs-mobile-backdrop {
        position: fixed; inset: 0;
        background: rgba(0,0,0,0.55);
        z-index: 1099;
        opacity: 0; pointer-events: none;
        transition: opacity .22s;
      }
      .gs-mobile-backdrop.open { opacity: 1; pointer-events: auto; }
      .gs-mobile-hamburger {
        display: none;
        align-items: center; justify-content: center;
        width: 34px; height: 34px; border-radius: 8px;
        border: none; background: rgba(255,255,255,0.07);
        color: rgba(255,255,255,0.65); cursor: pointer;
        transition: all var(--transition); flex-shrink: 0;
      }
      @media (max-width: 959px) {
        .gs-mobile-hamburger { display: flex; }
      }

      /* Responsive grid */
      .r-grid { display:grid; }
      .r-grid-2 { grid-template-columns:repeat(2,1fr);gap:14px; }
      .r-grid-3 { grid-template-columns:repeat(3,1fr);gap:14px; }
      .r-grid-4 { grid-template-columns:repeat(4,1fr);gap:14px; }
      .dash-row2 { grid-template-columns:1fr auto auto;gap:14px; }
      .dash-row3 { grid-template-columns:1fr 200px;gap:14px; }
      .dash-row5 { grid-template-columns:1fr 1fr;gap:14px; }

      /* Empty / Loading */
      .empty-state { display:flex;flex-direction:column;align-items:center;justify-content:center;padding:56px 24px;text-align:center;gap:8px; }
      .empty-state-icon { font-size:28px;opacity:.2;margin-bottom:4px; }
      .empty-state-text { font-size:13.5px;color:var(--textMuted);font-weight:500; }
      @keyframes spin { to { transform:rotate(360deg); } }
      .spinner { width:20px;height:20px;border:2.5px solid var(--border);border-top-color:var(--gold);border-radius:50%;animation:spin .7s linear infinite; }

      /* Page fade in */
      @keyframes fadeUp { from{opacity:0;transform:translateY(5px);}to{opacity:1;transform:translateY(0);} }
      .main-content > * { animation:fadeUp .18s ease both; }

      /* Responsive */
      @media (max-width: 960px) {
        .gs-sidebar { width: 0 !important; overflow: hidden !important; }
        .gs-main { margin-left: 0 !important; padding: 16px 16px 32px !important; }
        .gs-logo-zone { width: 0 !important; padding: 0 !important; border-right: none !important; overflow: hidden !important; }
        .hide-mobile { display: none !important; }
      }
      @media (max-width: 640px) {
        .form-grid,.form-grid-3{grid-template-columns:1fr!important;}
        .r-grid-2,.r-grid-3,.r-grid-4{grid-template-columns:1fr!important;}
        .dash-row2,.dash-row3,.dash-row5{grid-template-columns:1fr!important;}
        .grid-2col,.grid-3col,.grid-4col,.grid-5col{grid-template-columns:1fr!important;}
        .action-bar{flex-direction:column!important;align-items:stretch!important;}
        .action-bar>*{width:100%!important;}
        .modal-inner{max-width:calc(100vw - 16px)!important;padding:14px!important;margin:8px auto!important;}
        .gs-main{padding:12px 12px 24px!important;}
        .stat-value{font-size:22px!important;}
        .table-wrap{overflow-x:auto;}
        .layout-sidebar{grid-template-columns:1fr!important;}
        [style*="280px 1fr"],[style*="300px 1fr"],[style*="320px 1fr"],[style*="340px 1fr"],[style*="360px 1fr"],[style*="380px 1fr"]{grid-template-columns:1fr!important;}
        [style*="1fr 280px"],[style*="1fr 300px"],[style*="1fr 320px"],[style*="1fr 340px"],[style*="1fr 360px"],[style*="1fr 380px"]{grid-template-columns:1fr!important;}
        [style*="1fr 160px"],[style*="1fr 200px"],[style*="1fr 220px"],[style*="1fr 240px"],[style*="1fr 260px"]{grid-template-columns:1fr!important;}
      }
      @media (max-width: 1024px) {
        .r-grid-4{grid-template-columns:repeat(2,1fr);}
        .r-grid-3{grid-template-columns:repeat(2,1fr);}
        .dash-row2,.dash-row3{grid-template-columns:1fr!important;}
      }
    `}</style>

    <div className="gs-shell">

      {/* ══ TOPBAR ══ */}
      <header className="gs-topbar">

        {/* Logo zone */}
        <div className="gs-logo-zone" style={{ width: SIDE }}>
          <div className="gs-logo-mark">
            {theme.logoUrl
              ? <img src={theme.logoUrl} alt="logo" style={{width:'100%',height:'100%',objectFit:'contain',borderRadius:'50%'}}/>
              : <span style={{fontSize:14,fontWeight:800,color:SB}}>{(theme.hotelName||'GS').slice(0,2).toUpperCase()}</span>
            }
          </div>
          {!collapsed && (
            <div style={{minWidth:0}}>
              <div className="gs-logo-name">{theme.hotelName}</div>
              {theme.hotelTagline && <div className="gs-logo-tag">{theme.hotelTagline}</div>}
            </div>
          )}
        </div>

        {/* Breadcrumb */}
        <div className="gs-breadcrumb hide-mobile">
          <button onClick={() => setCollapsed(v=>!v)} className="topbar-icon-btn" aria-label="Toggle sidebar" style={{marginRight:4,flexShrink:0}}>
            <Ic d={I.menu} size={15}/>
          </button>
          <Ic d={I.home} size={12} style={{color:'rgba(255,255,255,0.4)'}}/>
          <span className="crumb-sep">›</span>
          <span style={{color:'rgba(255,255,255,0.6)',fontWeight:500}}>{ROLE_LABELS[user?.role]||'Dashboard'}</span>
          {breadcrumb && <>
            <span className="crumb-sep">›</span>
            <span className="crumb-active">{breadcrumb}</span>
          </>}
        </div>

        {/* Hamburger — mobile only */}
        <button className="gs-mobile-hamburger" aria-label="Open navigation" aria-expanded={mobileNavOpen}
          onClick={() => setMobileNavOpen(v => !v)} style={{marginLeft:8}}>
          <Ic d={I.menu} size={15}/>
        </button>

        {/* Right cluster */}
        <div className="gs-topbar-right">
          {/* Clock */}
          <button className="topbar-icon-btn hide-mobile" aria-label="Current time" style={{width:'auto',padding:'0 10px',gap:5,fontSize:12,fontWeight:600,color:'rgba(255,255,255,0.6)'}}>
            <Ic d={I.clock} size={13}/>
            {time}
          </button>

          {/* Dark toggle */}
          <button onClick={toggleMode} className="topbar-icon-btn" aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
            <Ic d={isDark ? I.sun : I.moon} size={15}/>
          </button>

          {/* Notifications */}
          <div style={{position:'relative'}}>
            <button onClick={() => onNotifClick?.()} className="topbar-icon-btn" aria-label={`Notifications${notifCount > 0 ? `, ${notifCount} unread` : ''}`}>
              <Ic d={I.bell} size={15}/>
              {notifCount > 0 && (
                <span style={{position:'absolute',top:1,right:1,background:GOLD,color:SB,
                  borderRadius:'50%',fontSize:8,fontWeight:800,width:15,height:15,
                  display:'flex',alignItems:'center',justifyContent:'center',lineHeight:1}}>
                  {notifCount > 9 ? '9+' : notifCount}
                </span>
              )}
            </button>
          </div>

          <div className="topbar-sep"/>

          {/* User */}
          <div style={{display:'flex',alignItems:'center',gap:8,padding:'4px 6px',borderRadius:8,cursor:'default',transition:'background var(--transition)'}}
            onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,0.08)'}
            onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
            <div className="gs-avatar" style={{width:28,height:28,background:GOLD,color:SB,fontSize:10,fontWeight:800}}>
              {ini(user?.name)}
            </div>
            <div className="hide-mobile" style={{lineHeight:1.3}}>
              <div style={{fontSize:12.5,fontWeight:700,color:'#fff'}}>{user?.name?.split(' ')[0]}</div>
              <div style={{fontSize:10,color:'rgba(255,255,255,0.45)'}}>{ROLE_LABELS[user?.role]}</div>
            </div>
          </div>

          {/* Logout */}
          <button onClick={logout} className="topbar-icon-btn" aria-label="Sign out"
            onMouseEnter={e=>{e.currentTarget.style.background='rgba(239,68,68,0.2)';e.currentTarget.style.color='#fca5a5';}}
            onMouseLeave={e=>{e.currentTarget.style.background='rgba(255,255,255,0.07)';e.currentTarget.style.color='rgba(255,255,255,0.65)';}}>
            <Ic d={I.logout} size={15}/>
          </button>
        </div>
      </header>

      {/* ══ SIDEBAR ══ */}
      <aside className="gs-sidebar noscroll" style={{width:SIDE}}>
        {/* Nav content */}
        <div style={{flex:1,overflowY:'auto',overflowX:'hidden',padding:'4px 0'}} className="noscroll">
          {sideContent}
        </div>

        {/* User card at bottom */}
        <div className="gs-sidebar-foot">
          <div className="gs-user-card">
            <div style={{display:'flex',alignItems:'center',gap:10,marginBottom: collapsed?0:8}}>
              <div className="gs-avatar" style={{width:36,height:36,background:GOLD,color:SB,fontSize:12,fontWeight:800,flexShrink:0}}>
                {ini(user?.name)}
              </div>
              {!collapsed && (
                <div style={{minWidth:0,flex:1}}>
                  <div style={{fontSize:12.5,fontWeight:700,color:'#fff',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{user?.name}</div>
                  <div style={{fontSize:10,color:'rgba(255,255,255,0.45)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{ROLE_LABELS[user?.role]}</div>
                </div>
              )}
            </div>
            {!collapsed && (
              <button onClick={logout} style={{
                width:'100%',padding:'6px 10px',borderRadius:8,border:'1px solid rgba(255,255,255,0.15)',
                background:'rgba(255,255,255,0.06)',color:'rgba(255,255,255,0.6)',
                fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:'inherit',
                transition:'all var(--transition)',marginTop:2,
              }}
                onMouseEnter={e=>{e.currentTarget.style.background='rgba(239,68,68,0.15)';e.currentTarget.style.color='#fca5a5';e.currentTarget.style.borderColor='rgba(239,68,68,0.3)';}}
                onMouseLeave={e=>{e.currentTarget.style.background='rgba(255,255,255,0.06)';e.currentTarget.style.color='rgba(255,255,255,0.6)';e.currentTarget.style.borderColor='rgba(255,255,255,0.15)';}}>
                Sign out
              </button>
            )}
          </div>
        </div>
      </aside>

      {/* ══ MAIN ══ */}
      <main className="gs-main main-content main-padding" style={{ marginLeft: SIDE, marginTop: TOP }}>
        {children}
      </main>

      {/* ══ MOBILE DRAWER ══ */}
      <div className={`gs-mobile-backdrop${mobileNavOpen ? ' open' : ''}`} onClick={closeMobileNav} aria-hidden="true"/>
      <nav className={`gs-mobile-drawer${mobileNavOpen ? ' open' : ''}`} aria-label="Mobile navigation" aria-hidden={!mobileNavOpen}>
        {/* Drawer header */}
        <div style={{display:'flex',alignItems:'center',gap:10,padding:'14px 16px',borderBottom:'1px solid rgba(255,255,255,0.08)',flexShrink:0}}>
          <div style={{width:32,height:32,borderRadius:'50%',background:GOLD,display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:800,color:SB,flexShrink:0}}>
            {theme.logoUrl
              ? <img src={theme.logoUrl} alt="logo" style={{width:'100%',height:'100%',objectFit:'contain',borderRadius:'50%'}}/>
              : <span>{(theme.hotelName||'GS').slice(0,2).toUpperCase()}</span>
            }
          </div>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:13,fontWeight:800,color:'#fff',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{theme.hotelName}</div>
            <div style={{fontSize:10,color:'rgba(255,255,255,0.4)',fontWeight:500}}>{ROLE_LABELS[user?.role]||'Staff'}</div>
          </div>
          <button onClick={closeMobileNav} className="topbar-icon-btn" aria-label="Close navigation" style={{flexShrink:0}}>
            <svg width={15} height={15} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
          </button>
        </div>

        {/* Nav items — tap to close */}
        <div style={{flex:1,overflowY:'auto',padding:'8px 0'}} onClick={closeMobileNav}>
          {sideContent}
        </div>

        {/* User footer */}
        <div style={{borderTop:'1px solid rgba(255,255,255,0.08)',padding:'14px 16px',flexShrink:0}}>
          <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:10}}>
            <div style={{width:34,height:34,borderRadius:'50%',background:GOLD,color:SB,display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:800,flexShrink:0}}>
              {ini(user?.name)}
            </div>
            <div style={{minWidth:0,flex:1}}>
              <div style={{fontSize:12.5,fontWeight:700,color:'#fff',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{user?.name}</div>
              <div style={{fontSize:10,color:'rgba(255,255,255,0.45)'}}>{ROLE_LABELS[user?.role]}</div>
            </div>
          </div>
          <button onClick={logout} style={{width:'100%',padding:'7px 12px',borderRadius:8,border:'1px solid rgba(255,255,255,0.15)',background:'rgba(255,255,255,0.06)',color:'rgba(255,255,255,0.65)',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:'inherit'}}>
            Sign out
          </button>
        </div>
      </nav>

    </div>
    </div>
  );
}